import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import PropTypes from "prop-types";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {
  MdHome,
  MdSearch,
  MdAccessTime,
  MdAdminPanelSettings,
  MdSettings,
  MdExpandMore,
  MdNotifications,
  MdGavel,
  MdFeed,
  MdEmail,
  MdAssessment,
  MdStore,
  MdHelpOutline,
  MdImage,
  MdSlideshow,
  MdMessage,
  MdCategory,
  MdMilitaryTech,
  MdExitToApp,
  MdClose,
  MdMenuBook,
  MdDesignServices,
  MdArticle,
  MdCastForEducation,
  MdNoteAdd,
} from "react-icons/md";
import { FaPercentage, FaUsers, FaUser } from "react-icons/fa";
import { RiListOrdered } from "react-icons/ri";
import { GiSlicedBread } from "react-icons/gi";
import NewspaperSharpIcon from "@mui/icons-material/NewspaperSharp";
import { StyledDrawerLink } from "../Link";
import {
  SearchBoxWrapper,
  StyledAppBar,
  StyledDrawer,
  StyledDrawerHeader,
  StyledInputBase,
  StyledList,
  StyledMain,
  StyledSearch,
  StyledTypo,
  StyledAccordion,
  StyledAccordionDetails,
  StyledSetting,
} from "./Drawer.style";
import { useLocation, useNavigate } from "react-router-dom";
import AccordionSummary from "@mui/material/AccordionSummary";
import useAuth from "hooks/use-auth";
import { useForm } from "react-hook-form";
import ImgContainer from "components/shared/Image";
import logo from "assets/img/logo-512.png";
import useHttp from "hooks/use-http";
// import { getAdminInfoRequest } from "api/requests/";
import { ADMIN_ROUTES } from "constants";
import { Sms } from "@mui/icons-material";
import { Badge } from "@mui/material";
import { useCallback } from "react";
import { getUnReadStatRequest } from "api/requests/stat";

const drawerWidth = 260;
let ADMIN_PREMISSION = { isPrimary: true, isMutated: false };

const SettingListItems = [
  { label: "تماس با ما", icon: <MdFeed size={26} />, url: "/aboutus" },
  { label: "گالری", icon: <MdImage size={26} />, url: "/gallery" },
];

function listItemsFunc(unReadCatalogs, unReadMessages) {
  return [
    {
      label: "کاربران",
      icon: <FaUser size={26} />,
      url: "/users",
    },
    {
      label: "کاتالوگ ها",
      icon: (
        <Badge color="error" badgeContent={unReadCatalogs}>
          <MdMenuBook size={26} />
        </Badge>
      ),
      url: "/catalogs",
    },
    {
      label: "محصولات",
      icon: <MdStore size={26} />,
      url: "/products",
    },
    {
      label: "خدمات",
      icon: <MdDesignServices size={26} />,
      url: "/services",
    },
    {
      label: "اخبار",
      icon: <MdArticle size={26} />,
      url: "/articles",
    },
    {
      label: "آموزش",
      icon: <MdCastForEducation size={26} />,
      url: "/education",
    },
    {
      label: "نمونه کار و سوابق",
      icon: <MdNoteAdd size={26} />,
      url: "/work_samples",
    },
    // {
    //   label: "ارسال پیامک",
    //   icon: <Sms size={26} />,
    //   url: "/sms",
    // },
    {
      label: "پیام ها",
      icon: (
        <Badge color="error" badgeContent={unReadMessages}>
          <MdMessage size={26} />
        </Badge>
      ),
      url: "/messages",
    },
    {
      label: "اسلاید صفحه اصلی",
      icon: <MdSlideshow size={26} />,
      url: "/slides",
    },
    // {
    //   label: "سوابق",
    //   icon: <MdNoteAdd size={26} />,
    //   url: "/records",
    // },
  ];
}
export default function DrawerCM(props) {
  const [unReadCatalogs, setUnReadCatalogs] = useState();
  const [unReadMessages, setUnReadMessages] = useState();

  const location = useLocation();
  const { request, loading, setLoading } = useHttp(false);
  const AuthCTX = useAuth();
  const currentPath = location.pathname.split()[0];
  const { register, getValues, reset } = useForm();

  const [listItems, setListItems] = useState(listItemsFunc(null, null));

  const [open, setOpen] = useState(window.innerWidth > 900 ? true : false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const getUnReadStat = useCallback(async () => {
    const res = await request({
      url: getUnReadStatRequest,
    });
    setUnReadCatalogs(res.unread_catalogs);
    setUnReadMessages(res.unread_contact_us);
  }, [request]);

  useEffect(() => {
    getUnReadStat();
  }, []);

  useEffect(() => {
    setListItems(listItemsFunc(unReadCatalogs, unReadMessages));
  }, [unReadCatalogs, unReadMessages]);

  return (
    <Box sx={{ display: "flex" }}>
      <StyledAppBar position="fixed" open={open} $drawerWidth={drawerWidth}>
        <Toolbar sx={{ color: (theme) => theme.palette.primary.contrastText }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ mr: 2, ...(open && { display: "none" }) }}
          >
            <MenuIcon />
          </IconButton>

          <StyledTypo variant="h6" noWrap component="div">
            {props.title}
          </StyledTypo>

          {props.onSearch && (
            <StyledSearch>
              <SearchBoxWrapper>
                <IconButton
                  aria-label="close"
                  sx={{ color: "white", mr: 0.5 }}
                  onClick={() => {
                    reset({ search: "" });
                    props.onSearch("");
                  }}
                >
                  <MdClose size={20} />
                </IconButton>

                <Divider
                  orientation="vertical"
                  variant="middle"
                  flexItem
                  light
                />

                <IconButton
                  aria-label="search"
                  sx={{ color: "white", ml: 0.5 }}
                  onClick={() => props.onSearch(getValues("search"))}
                >
                  <MdSearch size={20} />
                </IconButton>
              </SearchBoxWrapper>

              <StyledInputBase
                placeholder="جستجو"
                inputProps={{ "aria-label": "search" }}
                onKeyDown={(e) =>
                  e.key === "Enter" ? props.onSearch(getValues("search")) : ""
                }
                {...register("search")}
              />
            </StyledSearch>
          )}
        </Toolbar>
      </StyledAppBar>

      <StyledDrawer
        $drawerWidth={drawerWidth}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <StyledDrawerHeader item="styled_logo">
          <ImgContainer
            src={logo}
            alt="لوگو"
            objectFit="contain"
            width="150px"
            height="150px"
            sx={{ padding: "20px" }}
          />
          <IconButton
            onClick={handleDrawerClose}
            sx={{ mt: 1, alignSelf: "flex-start" }}
            size="large"
          >
            <ChevronRightIcon sx={{ color: "white" }} />
          </IconButton>
        </StyledDrawerHeader>

        <Divider />

        <StyledList>
          {ADMIN_PREMISSION.isPrimary
            ? listItems.map((item) => (
                <StyledDrawerLink
                  to={item.url}
                  $isActive={item.url === currentPath}
                  key={item.label}
                >
                  <ListItem button>
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText>{item.label}</ListItemText>
                  </ListItem>
                </StyledDrawerLink>
              ))
            : listItems.map((item) => {
                if (ADMIN_PREMISSION[item.url])
                  return (
                    <StyledDrawerLink
                      to={item.url}
                      $isActive={item.url === currentPath}
                      key={item.label}
                    >
                      <ListItem button>
                        <ListItemIcon>{item.icon}</ListItemIcon>
                        <ListItemText>{item.label}</ListItemText>
                      </ListItem>
                    </StyledDrawerLink>
                  );
              })}

          <StyledAccordion>
            <AccordionSummary
              expandIcon={<MdExpandMore size={26} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <StyledSetting>
                <ListItemIcon>
                  <MdSettings size={26} />
                </ListItemIcon>
                <ListItemText>درباره ما</ListItemText>
              </StyledSetting>
            </AccordionSummary>
            <StyledAccordionDetails>
              {SettingListItems.map((item) => (
                <StyledDrawerLink
                  to={item.url}
                  $isActive={item.url === currentPath}
                  key={item.label}
                >
                  <ListItem button>
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText>{item.label}</ListItemText>
                  </ListItem>
                </StyledDrawerLink>
              ))}
            </StyledAccordionDetails>
          </StyledAccordion>
          <ListItem button onClick={AuthCTX.logout}>
            <ListItemIcon>
              <MdExitToApp size={26} />
            </ListItemIcon>
            <ListItemText>خروج</ListItemText>
          </ListItem>
        </StyledList>
      </StyledDrawer>

      <StyledMain open={open} $drawerWidth={drawerWidth}>
        <StyledDrawerHeader />
        {props.children}
      </StyledMain>
    </Box>
  );
}

DrawerCM.prototype = {
  title: PropTypes.string,
  onSearch: PropTypes.func,
};
